module.exports = __webpack_public_path__ + "svg/attach.svg?7dce413eb87f40811692b1d1b74e270d";